module.exports = {"email":null,"code":null,"password":null,"token":null}


//////////////////
// WEBPACK FOOTER
// ./src/components/auth/forgot_pass/resources/model.json
// module id = J9pB
// module chunks = 1